import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import instantsearch from 'instantsearch.js';
import { liteClient } from 'algoliasearch/lite';
import { searchBox, hits } from 'instantsearch.js/es/widgets';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-people-instantsearch',
  templateUrl: './people-instantsearch.component.html',
  styleUrls: ['./people-instantsearch.component.scss']
})
export class PeopleInstantsearchComponent implements OnInit, OnDestroy {
  @Input() showId!: string;
  @ViewChild('searchBoxContainer', { static: true }) searchBoxContainer!: ElementRef;
  @ViewChild('hitsContainer', { static: true }) hitsContainer!: ElementRef;
  private searchInstance: any;
  public hasSearched = false;

  ngOnInit() {
    this.searchInstance = instantsearch({
      indexName: 'masterLists',
      searchClient: liteClient(environment.algolia.appId, environment.algolia.searchApiKey),
      insights: false,
    });

    this.searchInstance.addWidgets([
      searchBox({
        container: this.searchBoxContainer.nativeElement,
        placeholder: 'Search riders, trainers, horses, owners...',
        showReset: true,
        showSubmit: true,
        showLoadingIndicator: true,
        cssClasses: {
          input: 'form-control search-input',
        },
        queryHook: (query, search) => {
          this.hasSearched = !!query;
          search(query);
        }
      }),
      hits({
        container: this.hitsContainer.nativeElement,
        templates: {
          item: (hit: any) => `
           
              <div class="ais-Hits-main">
                <div class="ais-Hits-names">
                  <span class="ais-Hits-label">Rider:</span>
                  <a class="ais-Hits-rider" href="/entry/${this.showId}/${hit.entry}">${hit.riderName || ''}</a>
                  ${hit.trainerName ? `<span class="ais-Hits-label">Trainer:</span><a class="ais-Hits-trainer" href="/trainer-profile/${this.showId}/us_${hit.id_entrenador}">${hit.trainerName}</a>` : ''}
                </div>
                <div class="ais-Hits-horse">
                  <span class="ais-Hits-label">Entry:</span>
                  <a class="ais-Hits-horseName" href="/entry/${this.showId}/${hit.entry}">${hit.entry ? hit.entry + ' - ' : ''} ${hit.horseName || ''}</a>
                </div>
              </div>
           
          `,
          empty: () => this.hasSearched ? 'No people found for this show.' : '',
        },
        transformItems: (items: any[]) => items.filter(item => item.show == this.showId),
      }),
    ]);

    this.searchInstance.start();
  }

  ngOnDestroy() {
    if (this.searchInstance) {
      this.searchInstance.dispose();
    }
  }
}
